// Core Modules
import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, TitleStrategy, withInMemoryScrolling, withRouterConfig } from '@angular/router';

// External Modules
import { CacheFactory } from 'cachefactory';
import { NgxPermissionsModule } from 'ngx-permissions';
import { provideUserIdleConfig } from 'angular-user-idle';

// Tokens
import { WINDOW } from '@core/token/tokens';

// Interceptors
import { authInterceptor } from '@core/interceptors/auth.interceptor';

// Strategies
import { CustomTitleStrategy } from '@core/strategies/custom-title-strategies';

// Routes
import { routes } from '@app/app.routes';

// Environment
import { environment } from '@env/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    CacheFactory,
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    provideUserIdleConfig({
      idle: environment.SESSION.maxIdleWaitTime,
      timeout: environment.SESSION.logoutNotifyExpiryTime,
      ping: environment.SESSION.refreshSessionInterval,
    }),
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    {
      provide: WINDOW,
      useValue: window,
    },
  ],
};
